<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'colored-number',
  computed: {
    styles() {
      const styles: string[] = [];

      if (this.color) styles.push(`color: ${this.color}`);
      if (this.backgroundColor) styles.push(`background-color: ${this.backgroundColor}`);

      return styles.join(';');
    },
    classes() {
      const usedClasses: { [key: string]: boolean } = {};


      if (+this.number === 0) usedClasses['text-gray-300'] = true;
      else for (const cl of this.twClasses?.split(' ') || []) {
        usedClasses[cl] = true;
      }

      return usedClasses;
    },
    value() {
      if (this.number === null || this.number === undefined) return '';
      return +this.number ? this.number : '';
    }
  },
  props: ['number', 'color', 'backgroundColor', 'twClasses'],
});
</script>

<template>
  <span :class="classes" :style="styles">{{ value }}</span>
</template>

<style scoped lang="scss"></style>